<template>
  <div>
    <div class="home-container">
      <div class="hx-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>供应系统</el-breadcrumb-item>
          <el-breadcrumb-item>基地管理</el-breadcrumb-item>
          <el-breadcrumb-item>供应力上报</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="hx-form-container box-shadow">
        <el-form ref="listForm" :rules="checkListParams" :model="listParams" label-width="100px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="领货日期：" prop="dateId">
                <el-select clearable style="width: 100%" v-model="listParams.dateId" placeholder="请选择领货日期" size="small">
                  <el-option v-for="item in dateList" :value="item.id" :key="item.id" :label="item.title"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item>
                <el-button size="small" type="primary" @click="loadColumnTitle('listForm')"> 查询 </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <hx-table-result-col>
        <div class="wrap-table-info-display" style="height: 32px">
          <div style="position: absolute; right: 0">
            <el-button :disabled="!this.listParams.dateId" size="small" @click="loadTemplate" type="primary"> 上菜模板 </el-button>

            <el-button :disabled="!this.listParams.dateId" size="small" @click="resetTableData"> 重置 </el-button>

            <el-button :disabled="isDisabled || !this.listParams.dateId" type="success" size="small" @click="saveToDraft"> 保存为草稿 </el-button>

            <el-button :disabled="isDisabled || !this.listParams.dateId" type="primary" size="small" @click="dialogVisible = true"> 保存并提交 </el-button>

            <el-button size="small" type="text" @click="linkToRecordPage"> 历史记录 </el-button>
          </div>
        </div>
      </hx-table-result-col>

      <hx-table-result :show-pager-on-one-page="false" :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <el-table slot="content" :data="tableData" max-height="800" border>
          <el-table-column fixed align="center" width="60" label="序号">
            <template slot-scope="scope">
              <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
            </template>
          </el-table-column>

          <el-table-column prop="title" align="center" fixed label="产品名称"> </el-table-column>

          <el-table-column prop="spec" align="center" fixed label="规格"> </el-table-column>

          <el-table-column prop="little" align="center" label="基地供应能力"> </el-table-column>

          <el-table-column prop="little" align="center" label="基地上报量">
            <template slot-scope="scope">
              <el-input size="small" v-model.trim="scope.row.little" @change="reset($event, scope.$index)"></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" v-for="(item, index) in columnList" :key="index" :label="item.logisticName">
            <template slot-scope="scope">
              <el-input size="small" v-if="showSuplly(columnList[index].plaLogisticSiteId, scope.row.stockProportionList, index, scope.$index)" v-model.trim="scope.row.list[index]"></el-input>
              <span v-else>0</span>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>
    <el-dialog class="hx-login-out-template" title="提示" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false" :close-on-press-escape="false">
      <h3 class="align-center">确定提交供应能力上报？</h3>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="isDisabled" size="small" type="primary" @click="saveAndSubmit"> 确 定 </el-button>
        <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
      </span>
    </el-dialog>

    <el-dialog class="hx-login-out-template" title="上菜模板" :visible.sync="templateVisible" width="50%" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form v-loading="templateLoading" style="padding: 10px 20px" ref="templateForm" :model="templateParams" label-width="100px">
        <el-row :gutter="24">
          <el-form-item label="菜品名称：">
            <el-select
              @change="dishChanged"
              style="width: 100%"
              size="small"
              v-model="templateParams.dishId"
              filterable
              clearable
              remote
              reserve-keyword
              placeholder="请输入菜品名称"
              :remote-method="remoteMethod"
              :loading="dishesLoading"
            >
              <el-option v-for="item in dishesList" :label="item.title" :value="item.id" :key="item.title"> </el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <el-row :gutter="24">
          <el-form-item label=" ">
            <div v-for="(item, index) in categoryNameList" :key="index">
              <div class="e-tag-div-style">
                <span class="e-tag-title">{{ item.title }}：</span>
                <ul class="e-tag-ul-style">
                  <li v-for="(item1, index1) in dishes['categoryList_' + index]" class="e-tag-inline e-tag e-tag-info e-tag-mini" :key="index1">
                    <span class="el-tag-item-text">{{ item1.title }}</span>
                    <i class="e-tag-item-close el-icon-circle-close" @click="deleteItem(dishes['categoryList_' + index], index1, index)"> </i>
                  </li>
                </ul>
              </div>
            </div>
          </el-form-item>
        </el-row>

        <!-- <el-row :gutter="24">
          <el-form-item label="配送供应点：">
            <el-select
              multiple
              size="small"
              v-model="templateParams.supplyCentreIds"
              style="width: 100%;"
              clearable
            >
              <el-option
                v-for="item in supplyCentreList"
                :label="item.title"
                :value="item.id"
                :key="item.title"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-row> -->

        <el-form-item>
          <el-button size="small" type="primary" :disabled="templateBtnDisabled" @click="createTemplate"> 生成模板 </el-button>
          <el-button size="small" @click="templateVisible = false"> 取消 </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  data() {
    return {
      listParams: {
        dateId: "",
        farmId: "",
        supplyId: "",
      },
      checkListParams: {
        dateId: [{ required: true, message: "请先选择领货日期", trigger: "change" }],
      },
      date: "",
      dateList: [],
      columnList: [],
      logisticsSiteIdList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      isDisabled: false,
      dialogVisible: false,
      templateVisible: false,
      templateLoading: false,
      templateParams: {
        dishId: "",
        supplyCentreIds: [],
      },
      dishesLoading: false,
      dishesList: [],
      supplyCentreList: [],
      dishes: {},
      templateBtnDisabled: false,
      categoryNameList: [],
    };
  },
  created() {
    this.listParams.supplyId = this.$route.params.supplyId;
    this.listParams.farmId = parseInt(this.$route.params.baseId);
    this.loadSupplyDate();
    this.loadCategoryList();
    this.loadSupplyCentreList();
  },
  computed: {
    showSuplly() {
      return function (id, list, index, tabIndex) {
        let show = list.findIndex(item => {
          return id == item.plaLogisticSiteId;
        });
        if (show < 0) {
          return false;
        } else {
          return true;
        }
      };
    },
  },
  methods: {
    /**
    设置供应点的富余量
    */
    reset(e, index) {
      let list = new Array(this.columnList.length).fill(0);
      let stockProportionList = this.tableData[index].stockProportionList;
      stockProportionList.map(item => {
        let plaLogisticSiteId = item.plaLogisticSiteId;
        let index1 = this.columnList.findIndex(item1 => {
          return item1.plaLogisticSiteId == plaLogisticSiteId;
        });
        if (index1 >= 0) {
          list[index1] = ((item.stockProportion * e) / 100) >> 0;
        }
      });
      const array = JSON.parse(JSON.stringify(list));
      this.$set(this.tableData[index], "list", array);
    },
    /**
     * 初始化加载领货日期
     */
    loadSupplyDate() {
      this.$http({
        url: global.apiUrl + "/good/supplydate/findFarmDateAll",
        method: "GET",
        params: {
          supplyId: this.listParams.supplyId,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.dateList = res.body.data;
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化加载分类名称
     */
    loadCategoryList() {
      this.$http({
        url: global.apiUrl + "/good/goodcategory/findAll?supplyId=" + this.listParams.supplyId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.categoryNameList = res.body.data;
              const categoryObj = "categoryList_";
              res.body.data.map((item, index) => {
                this.dishes[categoryObj + index] = "";
              });
            }
          } else {
            this.categoryNameList = [];
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 初始化表头
     * name
     */
    loadColumnTitle(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$http({
            url: global.apiUrl + "/farm/farm-stock-name",
            method: "GET",
            params: {
              farmId: this.listParams.farmId,
              dateId: this.listParams.dateId,
            },
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                if (res.body.data && res.body.data.columnList) {
                  this.columnList = res.body.data.columnList;
                  // 避免重复push供应局Id
                  this.logisticsSiteIdList = [];
                  this.columnList.map(item => {
                    this.logisticsSiteIdList.push(item.plaLogisticSiteId);
                  });
                }
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      });
    },
    /**
     * 初始化列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-stock",
        method: "GET",
        params: this.listParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 初始化菜品模板
     */
    loadTemplate() {
      this.templateParams.dishId = "";
      // 每次初始化模板时清空所有菜品分类List数组
      for (const i in this.dishes) {
        this.dishes[i] = [];
      }
      this.templateVisible = true;
      this.templateLoading = true;
      const farmId = this.listParams.farmId;
      const dateId = this.listParams.dateId;
      this.$http({
        url: global.apiUrl + "/farm/farmTemplateQuery?farmId=" + farmId + "&dateId=" + dateId,
        method: "GET",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            const resData = res.body.data;
            resData.dishesList.map((val, index) => {
              for (const i in this.dishes) {
                if (i === val.type) {
                  this.dishes[i].push(val);
                }
              }
            });
            this.templateParams.supplyCentreIds = [];
            resData.supplyCentreList.map(val => {
              this.templateParams.supplyCentreIds.push(val.plaLogisticSiteId);
            });
            this.templateLoading = false;
          } else {
            this.templateLoading = false;
            this.message.error(res.body.info);
          }
        })
        .catch(err => {
          this.templateLoading = false;

          console.error(err);
        });
    },
    /**
     * 初始化供应点列表
     */
    loadSupplyCentreList() {
      this.$http({
        url: global.apiUrl + "/logistics/index",
        methods: "GET",
        params: {
          supplyId: this.listParams.supplyId,
          pageSize: 30,
          pageIndex: 1,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.supplyCentreList = res.body.data.dataList;
            } else {
              this.supplyCentreList = [];
            }
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * 远程搜索菜品
     * @param query
     */
    remoteMethod(query) {
      if (query !== "") {
        this.dishesLoading = true;
        this.$http({
          url: global.apiUrl + "/farm/farm-good-query",
          method: "GET",
          params: {
            dishname: query,
            dateId: this.listParams.dateId,
            supplyId: this.listParams.supplyId,
          },
        })
          .then(res => {
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              const resData = res.body.data;
              if (resData !== undefined && resData.length > 0) {
                this.dishesList = resData.map(val => ({
                  value: `${val.id}`,
                  label: `${val.title}`,
                }));
              }
              this.dishesLoading = false;
              this.dishesList = res.body.data;
            } else {
              this.dishesLoading = false;
            }
          })
          .catch(err => {
            this.dishesLoading = false;

            console.error(err);
          });
      } else {
        this.dishesList = [];
      }
    },
    /**
     * 菜品联想框change事件
     * @param id
     */
    dishChanged(id) {
      if (this.dishesList.length > 0) {
        this.dishesList.map(val => {
          if (val.id === id) {
            if (!this.isInArray(this.dishes[val.type], id)) {
              this.dishes[val.type].push(val);
            } else {
              this.$message.warning("请勿重复添加菜品");
            }
            if (this.dishesList.length === 1) {
              this.dishesList = [];
              this.templateParams.dishId = "";
            }
          }
        });
      }
    },
    /**
     * 判断菜品分类中是否包含所选商品
     * @param arr
     * @param value
     * @returns {boolean}
     */
    isInArray(arr, value) {
      for (let i = 0; i < arr.length; i++) {
        if (value === arr[i].id) {
          return true;
        }
      }
      return false;
    },
    /**
     * 删除菜品分类对应菜品数组
     * @param arr
     * @param index1
     */
    deleteItem(arr, index1, index) {
      arr.map((item, i) => {
        if (i === index1) {
          arr.splice(index1, 1);
        }
      });
      Vue.set(this.dishes, "categoryCopy", arr);
      delete this.dishes.categoryCopy;
    },
    /**
     * 生成模板
     */
    createTemplate() {
      const bodyParams = {};
      const templateDishesArr = [];
      if (this.dishes) {
        for (const i in this.dishes) {
          this.dishes[i].map(val => {
            templateDishesArr.push(val.id);
          });
        }
      }
      Object.assign(bodyParams, {
        farmId: this.listParams.farmId,
        dateId: this.listParams.dateId,
        dishesList: templateDishesArr,
        supplyCentreList: this.templateParams.supplyCentreIds,
      });
      this.templateBtnDisabled = true;
      this.$http({
        url: global.apiUrl + "/farm/farm-template-save",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.templateBtnDisabled = false;
            this.$message.success(res.body.info);
            this.templateVisible = false;
            setTimeout(() => {
              this.loadColumnTitle("listForm");
            }, 200);
          } else {
            this.templateBtnDisabled = false;
          }
        })
        .catch(err => {
          this.templateBtnDisabled = false;

          console.error(err);
        });
    },
    /**
     * 重置table数据
     */
    resetTableData() {
      this.tableLoading = true;
      this.tableData.map(item1 => {
        item1.little = "";
        item1.stock = "";
        item1.list.map((item2, i) => {
          item1.list[i] = "";
        });
      });
      this.tableLoading = false;
    },
    /**
     * 保存为草稿
     */
    saveToDraft() {
      this.isDisabled = true;
      const bodyParams = {
        farmId: this.listParams.farmId,
        supplyId: parseInt(this.$route.params.supplyId),
        dateId: this.listParams.dateId,
        logisticsSiteIdList: this.logisticsSiteIdList,
        tableList: this.tableData,
      };
      this.$http({
        url: global.apiUrl + "/farm/save-draft",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.isDisabled = false;
            this.loadTableData();
          } else {
            this.isDisabled = false;
          }
        })
        .catch(err => {
          this.isDisabled = false;

          console.error(err);
        });
    },
    /**
     * 保存并提交
     */
    saveAndSubmit() {
      this.isDisabled = true;
      const bodyParams = {
        farmId: this.listParams.farmId,
        supplyId: parseInt(this.$route.params.supplyId),
        dateId: this.listParams.dateId,
        logisticsSiteIdList: this.logisticsSiteIdList,
        tableList: this.tableData,
      };
      this.$http({
        url: global.apiUrl + "/farm/save-info",
        method: "POST",
        body: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.isDisabled = false;
            this.dialogVisible = false;
            this.listParams.dateId = "";
            this.loadSupplyDate();
            this.tableData = [];
          } else {
            this.isDisabled = false;
            this.dialogVisible = false;
          }
        })
        .catch(err => {
          this.isDisabled = false;
          this.dialogVisible = false;

          console.error(err);
        });
    },
    /**
     * 跳转至历史记录页
     */
    linkToRecordPage() {
      this.$router.push({
        name: "record",
      });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
